module.exports = __webpack_public_path__ + "img/data-item1-5.f2b0fec.png";